// extracted by mini-css-extract-plugin
export default {"component":"bPOfBs","great":"cPOfBs","good":"dPOfBs","fair":"ePOfBs","poor":"fPOfBs","off-range":"gPOfBs","no-data":"hPOfBs"};